module.exports = __webpack_public_path__ + "images/emoji/nail_care.3b80f0531fdf19137d48.png";